// Step assets
import Step4Img from '../assets/images/wayabank_steps/dashboard.png';
import Step3Img from '../assets/images/wayabank_steps/fund.png';
import Step1Img from '../assets/images/wayabank_steps/register.png';
import Step2Img from '../assets/images/wayabank_steps/verify.png';

// Section Images
import PersonalImg from '../assets/images/personal.png';
import BusinessImg from '../assets/images/waya_business_banking_v2.png';
import WayaGramIcon from '../assets/wayagram.png';
import WayaPosIcon from '../assets/wayaPos.png';
import WayaQuickIcon from '../assets/wayaquick.png';

// Legal / Partner Logos
import CbnLogo from '../assets/images/legal/cbn.png';
import NdicLogo from '../assets/images/legal/ndic.png';
import Wayalinks from '../assets/images/legal/wayalinks logo.png';

// Hero assets
import Phone from '../assets/images/new_images/Hero Banner Effects/Phone.png';
import HeroPhoneMockup from '../assets/images/phone_wayabank.png';

// Contact assets
import customerRep from '../assets/images/constomer_rep_wb.jpg';

/* ─────────────────────────────────────────────────────────────
   CENTRALIZED WEBSITE CONTENT STORE (CRM-READY SCHEMA)
───────────────────────────────────────────────────────────── */
export const websiteData = {
  // Global Settings / Company Details
  settings: {
    site_name: 'WayaBank',
    contact_email: 'customerservice@wayapaychat.com',
    contact_phone: '0700CALLWAYA',
    address: '14 Yeye olofin street, Lekki, Lagos, Nigeria',
    cbn_logo: CbnLogo,
    ndic_logo: NdicLogo,
    app_store_url: 'https://apps.apple.com/us/app/wayabank/id1658552439',
    play_store_url: 'https://play.google.com/store/apps/details?id=ng.wayabank',
    footer_description:
      'WayaBank is a product of WayaLinks Limited. [CBN Licence No. XXXXX]. Customer deposits are insured by the Nigeria Deposit Insurance Corporation (NDIC). Registered address: 14 Yeye olofin street, Lekki, Lagos, Nigeria. RC No. [Registered Company Number].',
    mission:
      'WayaBank is part of WayaLinks, a Nigerian-built technology ecosystem connecting people, businesses, and communities to the digital economy. From informal traders in Lagos to SMEs across the country, we are banking the unbanked, one account at a time.',
    whatsapp_number: '2347066750658',
    whatsapp_message: 'I am here to make enquiries...',
    whatsapp_url: 'https://wa.me/2347066750658',
    b2b_documentation: '',
  },

  // About Section (Home Page)
  aboutSection: {
    badge: 'ABOUT WAYABANK',
    titleFirstPart: 'Banking built for the ',
    titleHighlightPart: 'everyday Nigerian',
    description: 'WayaBank is part of WayaLinks, a Nigerian-built technology ecosystem connecting people, businesses, and communities to the digital economy. From informal traders in Lagos to SMEs across the country, we are banking the unbanked, one account at a time.',
    trustCards: [
      {
        title: 'Safe & Secure Transactions',
        body: 'Your money is secure, your transactions are visible in real time, and our support team is reachable when you need them. That is not a claim. That is how we are built.',
      },
      {
        title: 'Lowest Transaction Fees',
        body: 'Transfers that cost less than a bus fare. 10 naira per transaction, nothing hidden, nothing unexpected.',
      },
      {
        title: '24/7 Support',
        body: 'Our support team is always on standby, day or night. Reach us via the app, live chat, or WhatsApp.',
      },
      {
        title: 'Built in Nigeria, for Nigerians',
        body: 'A proudly Nigerian product built for African communities. Your account connects directly to WayaQuick and WayaGram for a seamless, all-in-one financial ecosystem.',
      },
    ]
  },

  // About Page
  aboutIntro: {
    pill: 'About Us',
    title:
      'Banking is Just the Beginning. <br class="d-none d-lg-block" /> We Are the Engine of Your Growth.',
    content:
      'At WayaBank, we believe that access to seamless financial services is a right, not a privilege. Today, we are more than just a bank — we are a world-class technology engine driving unstoppable growth for thousands of entrepreneurs and millions of individuals across Nigeria.',
    mission_title: 'Our Mission',
    advantages_title: 'The WayaBank Advantage: Why We Stand Out',
  },

  aboutContent: [
    {
      id: 'f1',
      title: 'For the Hustlers and the Builders',
      content:
        'Small and medium-sized enterprises are the lifeblood of the Nigerian economy. We provide the tools to make your business unstoppable.',
      image_url:
        'https://images.unsplash.com/photo-1556742044-3c52d6e88c62?auto=format&fit=crop&w=800&q=80',
      tag: 'For SMEs & Businesses',
    },
    {
      id: 'f2',
      title: 'For Every Nigerian',
      content:
        'Your money should work for you, on your terms. We power millions of individuals with an intuitive digital banking experience.',
      image_url:
        'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80',
      tag: 'For Individuals',
    },
  ],

  // Home Page Content
  homeContent: {
    hero_headline: 'BANKING FOR THE WAY YOU LIVE. | Designed around your everyday.',
    hero_subtext:
      'WayaBank is built for how Nigerians actually live. Open a free account in minutes and send money, pay bills, request loans, and run your business, anytime, anywhere.',
    hero_image_1: HeroPhoneMockup,
    hero_image_2: Phone,
    pill_text: 'Bank for Every Nigerian. Built for your life. Powered by WayaLinks.',
    app_store_url: 'https://apps.apple.com/us/app/wayabank/id1658552439',
    play_store_url: 'https://play.google.com/store/apps/details?id=ng.wayabank',
    stats: [
      { value: '250K+', label: 'Active users' },
      { value: '₦28B+', label: 'Processed' },
      { value: '99.9%', label: 'Uptime' },
    ],
  },

  // Banking Details //
  bankingDetails: {
    personal: {
      sectionTagline: 'Personal Banking',
      title: 'Built for the market, not just the office.',
      description:
        'WayaBank is also building for Mama Bisi. The tomato seller. The mama put owner. The market trader who has never been inside a bank branch and deserves one anyway. Whether you sell tomatoes or run a growing business, WayaBank works for you.',
      image_url: 'https://img.magnific.com/premium-photo/woman-standing-busy-market-engrossed-her-cell-phone-checking-her-messages-portrait-smiling-african-woman-using-mobile-phone-local-market-ai-generated_538213-24640.jpg',
      bullets: [
        'Open your account on your phone',
        'Accept payments on a POS',
        'Get real-time alerts before you release goods',
        'Keep a transaction record you can show when you need a loan',
        'WayaBank gives you legitimacy, and it gives it to you on your terms',
      ],
    },
    business: {
      sectionTagline: 'Business Banking',
      title: 'Built to power your business.',
      description:
        'Run your business payments without the friction. Bulk transfers, invoicing, POS management, and business loans — all in one app built for how Nigerian businesses actually work.',
      image_url: BusinessImg,
      bullets: [
        'Bulk Transfers — Pay staff, suppliers, or vendors in one action via CSV/Excel upload.',
        'Invoicing — Create and settle invoices directly from your WayaBank dashboard.',
        'Business POS — Accept payments anywhere: market, store, or on the go.',
        'Business Loans — Apply for capital and get funds when you need them most.',
        'Multi-Account Banking — Manage personal and business finances on the same platform.',
      ],
      stats: [
        { value: '250K+', label: 'Customers' },
        { value: '₦2B+', label: 'Processed' },
      ],
    },
  },

  // Advantages (Why WayaBank Stands Out)
  advantages: [
    {
      title: 'Safe & Secure Transactions',
      desc: 'Your money is secure, transactions are visible in real time, and our support team is always reachable. That is not a claim — that is how we are built.',
    },
    {
      title: 'Lowest Transaction Fees',
      desc: 'Transfers that cost less than a bus fare. ₦10 per transaction, nothing hidden, nothing unexpected.',
    },
    {
      title: '24/7 Support',
      desc: 'Our support team is always on standby. Reach us via the app, live chat, or WhatsApp — day or night.',
    },
    {
      title: 'Built in Nigeria, for Nigerians',
      desc: 'Built for Africa by WayaLinks, uniting banking, payments, and marketplace into one seamless ecosystem.',
    },
  ],

  // FAQs (Decoupled, predicts CRM layout)
  faqs: {
    personal: [
      {
        question: 'How do I open a WayaBank Personal Account?',
        answer: 'Download the WayaBank app from the Play Store or App Store, then use your Phone Number and BVN to register in minutes.',
      },
      {
        question: 'Is there a maintenance fee for my account?',
        answer: 'No. WayaBank personal accounts come with zero monthly maintenance fees.',
      },
      {
        question: 'What are the requirements to open a Personal Account?',
        answer: 'To open a Personal Account, you need a valid Nigerian Phone Number, an Email Address, your First Name, Last Name, Date of Birth, Gender, and your Bank Verification Number (BVN) for identity verification.',
      },
      {
        question: 'Is my BVN safe when opening a WayaBank Personal Account?',
        answer: 'Yes, WayaBank uses secure BVN verification in accordance with CBN regulations, ensuring your personal details are fully encrypted and safe.',
      },
      {
        question: 'Can I upgrade my personal account tier?',
        answer: 'Yes, you can upgrade your account tier by providing additional identity documentation such as a government-issued ID (NIN, Voter Card, International Passport) and proof of address in the settings section of the app.',
      },
      {
        question: 'How secure is my money with WayaBank?',
        answer: 'WayaBank is licensed by the CBN and insured by the NDIC. Your funds are protected at every layer.',
      },
    ],
    business: [
      {
        question: 'What are the requirements to open a Business Account?',
        isStructured: true,
        intro: 'There are two options available for creating a Business Account on Wayabank:',
        options: [
          {
            title: 'Business Account Without CAC Registration',
            subtitle: 'This option is for small businesses or individuals operating without a registered business name.',
            required: [
              'Email Address',
              'Phone Number',
              'First Name',
              'Last Name',
              'Date of Birth',
              'Gender',
              'BVN',
              'Password',
              'Business Name'
            ],
            optional: [
              'Referral Code'
            ]
          },
          {
            title: 'Business Account With CAC Registration',
            subtitle: 'This option is for businesses already registered with CAC (Corporate Affairs Commission).',
            required: [
              'Business Name',
              'Registration Number',
              'CAC Number',
              'Tax Identification Number (TIN)',
              'Business Type',
              'Registration/Incorporation Date',
              'Business Address',
              'City',
              'State',
              'Country',
              'Email Address',
              'Phone Number',
              'Trade Name',
              'Postal Address',
              'Directors’ Details',
              'Shareholders’ Details',
              'References'
            ],
            optional: [
              'Website'
            ]
          }
        ],
        notice: 'All mandatory fields marked with a red asterisk (*) must be completed before submission.'
      },
      {
        question: 'Can I open a business account without CAC registration?',
        answer: 'Yes, you can create a Business Account without CAC registration using your personal details and business name.',
      },
      {
        question: 'Do I need BVN to open a business account?',
        answer: 'Yes, BVN is required for verification purposes.',
      },
      {
        question: 'Is CAC compulsory for all business accounts?',
        answer: 'No. CAC registration is only required for businesses opening a registered business account.',
      },
      {
        question: 'What happens if I do not complete all required fields?',
        answer: 'Your application may not be submitted successfully until all mandatory fields are completed.',
      },
    ],
  },

  // Testimonials fallbacks
  testimonials: [
    { name: 'Elera Obarijima', source: 'App Store', text: 'Great app with a clean interface and smooth transactions.' },
    { name: 'Usman John', source: 'Play Store', text: 'Wayabank are the best online banking app, very seamless.' },
    { name: 'Damiiiiidaniel', source: 'App Store', text: 'Smooth transfers and no complications so far.' },
    { name: 'jgkcd', source: 'App Store', text: 'Fast transactions and easy navigation.' },
    { name: 'Mackd45', source: 'App Store', text: 'Amazing social community with a well structured interface.' },
    { name: 'June Johnson', source: 'Play Store', text: 'I find it very easy to use.' },
  ],

  // Partners / Logos
  partners: [
    { name: 'WAYALINKS', type: 'ecosystem', image_url: Wayalinks }
  ],

  // Ecosystem Details
  ecosystem: [
    {
      title: 'WayaGram',
      description: 'Discover beautiful places, people, conversations, vendors and clients.',
      buttonText: 'Explore',
      type: 'gram',
      image_url: WayaGramIcon,
    },
    {
      title: 'WayaQuick',
      description: 'Accept payment on your website or mobile app via card, USSD, bank, or wallet.',
      buttonText: 'Explore',
      type: 'pay',
      image_url: WayaQuickIcon,
    },
    {
      title: 'WayaPos',
      description: 'Accept Mastercard, VISA and Verve cards at your physical store.',
      buttonText: 'Explore',
      type: 'pos',
      image_url: WayaPosIcon,
    },
  ],

  // CTAs
  ctaSections: {
    support: {
      title: "Have an issue? We're here to help.",
      subline: 'Our dedicated support team is available 24/7 to assist you with any questions.',
    },
    about: {
      title: 'Join the Financial Revolution',
      subline:
        "The future of banking isn't coming — it's already here. Stop settling for financial institutions that slow you down.",
    },
  },

  // Features list
  features: [
    { title: 'Send & Receive Money Instantly', body: 'Transfer money to any Nigerian bank account, phone number, or email in seconds. Safe, fast, and always confirmed.' },
    { title: 'Pay Bills From Wherever You Are', body: 'Airtime, data, DSTV, PHCN, water, and more. Pay everything from one app — no cash, no stress.' },
    { title: 'Get a Loan When You Need It', body: 'Apply for a personal or travel loan directly from the WayaBank app. No long forms, no long waits.' },
    { title: 'Use WayaBank Even Without Internet', body: 'No data? No problem. WayaBank works on any phone, anywhere in Nigeria — dial in and bank.' },
    { title: 'Get Your WayaBank ATM Card', body: 'Withdraw cash from ATMs across Nigeria. Your WayaBank account, your card, your access.' },
    { title: 'Earn When You Refer Friends', body: 'Every friend you bring to WayaBank puts something back in your pocket. Share the link, earn the reward.' },
  ],

  // Onboarding / How it Works Steps
  howItWorks: {
    steps: [
      {
        title: 'Step 1 — Find WayaBank',
        description: "Search 'WayaBank' on Google, the App Store, or Google Play. You are already in the right place.",
        image_url: Step1Img,
      },
      {
        title: 'Step 2 — Download the App',
        description: 'Available on Android and iOS. Download in seconds and open the app to begin.',
        image_url: Step2Img,
      },
      {
        title: 'Step 3 — Create Your Account',
        description: "Sign up with your phone number or email. Verify your identity quickly — WayaBank's Auto-KYC makes it painless.",
        image_url: Step3Img,
      },
      {
        title: 'Step 4 — Start Transacting',
        description: 'Send money, pay bills, request loans, and manage your finances from day one.',
        image_url: Step4Img,
      },
      {
        title: 'Step 5 — Refer & Earn',
        description: 'Every friend you bring to WayaBank puts something back in your pocket. Share the link, earn the reward.',
        image_url: Step4Img,
      },
    ],
  },

  // WayaChat Content Page
  wayaChatPage: {
    uniqueFeaturesTitle: 'Unique Features',
    uniqueFeaturesSub: 'Enable your business with the appropriate tools to acknowledge online payments and give the best client experience',
    features: [
      {
        img: '/posfeat/1.png',
        title: 'Instant Activation',
        description: 'Get enacted and execute inside 2 minutes. Totally internet onboarding with least documentation.'
      },
      {
        img: '/posfeat/2.png',
        title: 'Easy Integration',
        description: 'With modules for every significant stage and dialects, coordinate and go live with wayaPay in under 60 minutes.'
      },
      {
        img: '/posfeat/3.png',
        title: 'API Driven',
        description: 'Assemble your business for scale with our total API-driven robotization that requires zero manual intercession.'
      },
      {
        img: '/posfeat/4.png',
        title: 'Multiple payment methods',
        description: 'Offer your customer the luxury of payment method that waya pay supports including credit/debit cards, USSD, Bank and wallets'
      },
      {
        img: '/posfeat/5.png',
        title: 'Simple Pricing',
        description: 'Our imaginative installment arrangements with serious evaluating simplify installments.'
      },
      {
        img: '/posfeat/6.png',
        title: 'Best in Industry Support',
        description: 'Continuously accessible email, telephone and talk based help to help you in all your means.'
      },
      {
        img: '/posfeat/7.png',
        title: 'Dashboard Reporting',
        description: 'Continuous information and bits of knowledge on your Wayapay Dashboard to settle on informed business choices.'
      },
      {
        img: '/posfeat/8.png',
        title: 'Secure',
        description: 'PCI DSS Level 1 consistent arrangement which eliminates your weight of administrative consistence.'
      },
    ],
    onboardTitle: 'Get onboarded and begin accepting payments in no time.',
    onboardSteps: [
      { text: 'Register account with us', link: '/signup' },
      { text: 'Perform test mode transactions by using test API keys' },
      { text: 'Submit compliance form' },
      { text: 'Start collecting real-life payment from your customers either by integrating with our platforms or using our payment link feature.' }
    ]
  },

  // WayaPay Content Page
  wayaPayPage: {
    heroTitle: 'Send money to friends and family or get payments from your customers',
    heroSub: 'Waya PayChat digital wallet is an all - in - one platform to perform safe and secure transactions, pay your bills and socialize with friends and family.',
    gridBoxes: [
      {
        id: 'wallet',
        image: '/digital.png',
        title: 'DIGITAL WALLET',
        description: 'Digital wallet personalised for you to store funds safely, receive money, budget spendings, pay bills'
      },
      {
        id: 'sendMoney',
        image: '/sendmoney.png',
        title: 'SEND MONEY',
        description: 'Send money using WayaPay at insanely fast, secure and cheap rates either as a customer or agent'
      },
      {
        id: 'withdraw',
        image: '/withdraw.png',
        title: 'WITHDRAW MONEY',
        description: 'Withdraw money from your WayaPay digital wallet direct to your bank account or any WAYA Agent'
      },
      {
        id: 'qr',
        image: '/scan.png',
        title: 'qr code scanner',
        description: 'WayaPay’s scan and pay feature helps ypu transfer or receive funds without needing a bank account or phone number. Just whip out your app, scan and pay and the fund is transferred easy peasy!'
      },
      {
        id: 'bills',
        image: '/bill.png',
        title: 'pay bills',
        description: 'Pay bills using our digital wallet with our list of growing merchants who use WayaPay as their preferred way of receiving money from their customers, school fess, hotel booking, visa payment, utility bills, church, mousque and religious expenses etc.'
      },
      {
        id: 'checkout',
        image: '/paying.png',
        title: 'online checkout',
        description: 'Online checkout has never been easier with WayaPay digital wallet, pay for your online shopping across several top websites like Jumia, Amazon, Konga, Alibaba etc. WayaPay affords every user simple and easy way to create instant virtual cards to shop and enjoy befitting lifestyle.'
      },
      {
        id: 'rmoney',
        image: '/request.png',
        title: 'REQUEST MONEY',
        description: 'Request and receive money from friends and families, customers etc, using phone number through WayaPay'
      },
      {
        id: 'invoice',
        image: '/settle.png',
        title: 'settle invioce',
        description: 'Settle invoice from customers, WayaPay enables easy settlement and clearing for smooth business operation'
      },
      {
        id: 'tvSub',
        image: '/subs.png',
        title: 'pay tv subscription',
        description: 'Pay - TV subscription for your pay - TV like DSTV, GoTV, TSTV etc'
      },
      {
        id: 'topUp',
        image: '/mobile-phoneOne.png',
        title: 'top-up airtime and data',
        description: 'Request and receive money from friends and families, customers etc, using phone number through WayaPay'
      }
    ]
  },

  // WayaGram Content Page
  wayaGramPage: {
    longText: 'Connect with friends, share what you’re uo to, or see what’s new from others all over the world. Explore our community where you can feel free to be yourself and share everything from your daily moments to life’s hignlights.',
    heroTitle: 'Socialize',
    gridData: [
      {
        title: 'make post',
        image: '/post.png',
        id: 'post',
        text: 'Make short posts and share across moments with friends and families'
      },
      {
        title: 'join group',
        image: '/Group.png',
        id: 'group',
        text: 'Join group, follow events, like and follow personal and business pages'
      },
      {
        title: 'Socialize',
        image: '/socializeIcon.png',
        id: 'socialize',
        text: 'Socialise with the power of a growing community on WayaGram, express yourself within the limits of boundless freedom'
      },
      {
        title: 'Vote',
        image: '/vote.png',
        id: 'vote',
        text: 'Participate in poll on WayaGram, vote for friends and families with WayaGram'
      },
      {
        title: 'enjoy moments',
        image: '/smileys.png',
        id: 'moments',
        text: 'Watch short clips of your followers or any other WayaGram user. enjoy momemts, like and share with others in your timeline'
      },
      {
        title: 'advertise',
        id: 'advertise',
        image: '/marketing.png',
        text: 'Advertise and sell your product on the fastest growing social media platfrom growing from Nigeria and spreading throughout Africa'
      },
      {
        title: 'share live screen',
        image: '/live.png',
        id: 'live',
        text: 'Share live screen with anyone to follow and watch you on the move and as you host events. distance is not a barrier with the live screen feature of WayaGram. Share precious moments as they are happening live.'
      },
      {
        title: 'campaign',
        image: '/coms.png',
        id: 'campaign',
        text: 'Launch campaigns, anyone or entity can launch campaigns on WayaGram for personal, corporate, public and non-governmental events. WayaGram is the perfect tool for social momets'
      }
    ]
  },

  // Pricing Page Content
  pricingPage: {
    listData: [
      { title: 'Transfers of NGN 5,000 and below' },
      { title: 'Transfers between NGN 5,001 and NGN 50,000' },
      { title: 'Transfers of NGN 5,000 and below' },
    ],
    faqData: [
      {
        title: 'When do I receive my money?',
        description: 'You will receive your money the next day for local payments. International payment varies depending on your region.'
      },
      {
        title: 'Are there any transaction limits?',
        description: 'Yes, there are transaction limits. Transaction limits apply to the different types of accounts.'
      },
      {
        title: 'Who bears the transaction charge?',
        description: 'By default, your customers bear the transaction charges. You can change this on your dashboard anytime to your preference.'
      },
      {
        title: 'Who bears the transaction charge?',
        description: 'By default, your customers bear the transaction charges. You can change this on your dashboard anytime to your preference.'
      }
    ]
  },

  // Contact Page Content
  contactPage: {
    heroTitle: "We're here to help you grow.",
    heroSub: 'Have questions or need assistance? Our support team is available 24/7 to ensure your banking experience is seamless.',
    formTitle: 'Send us a message',
    formSub: "Fill out the form below and we'll get back to you within 24 hours.",
    formUrl: 'https://forms.zohopublic.com/wayabank/form/ComplaintTicketingForm/formperma/ut_-h9uwYeIcgRv0goP-ZanRBHFZwWP9_udhzLdUUKI?zf_rszfm=1',
    customerImage: customerRep,
  }
};
